import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

const ALLOWED_PROTOCOLS = ['https:', 'http:'];

/**
 * Marks an http(s) URL as a trusted resource URL (e.g. for iframe [src]).
 * Any other scheme (javascript:, data:, ...) or unparsable value is rejected and yields null.
 * Only use with URLs built from trusted configuration, never with raw user input.
 */
@Pipe({
  name: 'safe',
  standalone: false
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl | null {
    if (!SafePipe.isAllowedUrl(url)) {
      return null;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private static isAllowedUrl(url: string): boolean {
    try {
      return ALLOWED_PROTOCOLS.includes(new URL(url, window.location.origin).protocol);
    } catch {
      return false;
    }
  }
}
